
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/dialog";
import { Home, PlusSquare, LifeBuoy, HelpCircle, ChevronDown, ChevronUp } from "lucide-react";
import SupportDialog from './support/SupportDialog';
import { useTour } from './onboarding/TourContext';
import { useIsMobile } from '../hooks/use-mobile';
import { Capacitor } from '@capacitor/core';

const Menu = () => {
  const navigate = useNavigate();
  const [showSupport, setShowSupport] = React.useState(false);
  const [isExpanded, setIsExpanded] = React.useState(true);
  const { startTour } = useTour();
  const isMobile = useIsMobile();
  const isNative = Capacitor.isNativePlatform();

  return (
    <>
      {/* Collapsed state - small toggle button */}
      {!isExpanded && (
        <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-10">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsExpanded(true)}
            className="bg-card border border-border rounded-full shadow-lg"
          >
            <ChevronUp className="h-5 w-5 text-foreground" />
          </Button>
        </div>
      )}

      {/* Expanded state - full menu */}
      {isExpanded && (
        <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 flex gap-4 bg-card border border-border rounded-full shadow-lg p-2 z-10 transition-all duration-300">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate('/')}
          >
            <Home className="h-5 w-5 text-foreground" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate('/editor')}
          >
            <PlusSquare className="h-5 w-5 text-foreground" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setShowSupport(true)}
          >
            <LifeBuoy className="h-5 w-5 text-foreground" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={startTour}
            className="tour-help-button"
          >
            <HelpCircle className="h-5 w-5 text-foreground" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsExpanded(false)}
            className="border-l border-border pl-2"
          >
            <ChevronDown className="h-5 w-5 text-foreground" />
          </Button>
        </div>
      )}

      <Dialog open={showSupport} onOpenChange={setShowSupport}>
        <SupportDialog />
      </Dialog>
    </>
  );
};

export default Menu;
